import React from 'react'
import { Button, Icon } from '@drifthq/tide-core'

import RIGHT_ARROW_WITH_TEXT from 'images/RIGHT_ARROW_WITH_TEXT.svg'

import './style.css'

const getInitials = name => {
  const names = name.split(' ')
  
  // Get first name and first letter of first name
  let initials = names[0].substring(0, 1).toUpperCase()
  
  if (names.length > 1) {
    // Get first letter for last name if there is more than one name
    initials += names[names.length - 1].substring(0, 1).toUpperCase()
  }
  
  return initials;
}

const PreviewButton = ({ color, filled, children }) => (
  <Button
    disabled
    className="setup-profile-preview-button"
    style={{
      borderColor: color,
      backgroundColor: filled ? color : 'white',
      color: filled ? 'white' : color,
    }}
  >
    {children}
  </Button>
)

const ProfilePreview = ({ coverPhotoUrl, stagedProfilePicture, companyName, color, name }) => (
  <div className="setup-profile-preview">
    <div className='profile-preview-right-arrow-with-text'>
      <img src={RIGHT_ARROW_WITH_TEXT} alt='This is what your profile will look like'/>
    </div>
    <div
      className="setup-profile-preview-photo"
      style={{
        background: coverPhotoUrl
          ? `url(${ coverPhotoUrl}) center center / cover no-repeat` 
          : stagedProfilePicture
            ? `url(${stagedProfilePicture.preview}) center center / cover no-repeat` 
            : '#87CEFA',
      }}
    >
      {!(coverPhotoUrl || stagedProfilePicture) && name && (
        <div className='setup-profile-abbreviated-name'>
          {name && getInitials(name)}
        </div>
      )}
    </div>
    <div className="setup-profile-preview-info">
      <Icon
        name="drift-logo-full"
        className="setup-profile-preview-drift-logo"
        width={60}
      />
      <p className="setup-profile-preview-name">{name}</p>
      <div className="setup-profile-preview-online">
        <div className="setup-profile-preview-online-dot"/>
        online now
      </div>
      <div className="setup-profile-preview-field">
        {companyName &&
          <div>
            <Icon name="briefcase"/>
            <span className="setup-profile-preview-company-name">{companyName}</span>
          </div>
        }
      </div>
      <div className="setup-profile-preview-actions">
        <PreviewButton filled color={`#${color}`}>
          <Icon name="chat-1"/>
          Chat With Me
        </PreviewButton>
        <PreviewButton color={`#${color}`}>
          <Icon name="calendar-check"/>
          Schedule a Meeting
        </PreviewButton>
        <PreviewButton color={`#${color}`}>...</PreviewButton>
      </div>
    </div>
  </div>
)

export default ProfilePreview



// WEBPACK FOOTER //
// ./src/layouts/ProfilePreview/component.js